import {useEffect as reactUseEffect, useState, type DependencyList} from 'react';

export function useEffect(effect: () => void | Promise<void>, dependencies: DependencyList) {
  reactUseEffect(() => { void effect(); }, dependencies);
}

export function useAsync<T>(loader: () => Promise<T>, dependencies: DependencyList) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState('');
  const [version, setVersion] = useState(0);
  useEffect(async () => {
    setError('');
    try { setData(await loader()); } catch (e) { setError(e instanceof Error ? e.message : 'Request failed'); }
  }, [...dependencies, version]);
  return {data, error, reload: () => setVersion(value => value + 1)};
}
